import React from 'react'
import { Input, Label, PasswordWithConfirm } from '@/shared/ui'
import PhoneInputIntl from '@/shared/ui/PhoneInputIntl'

export type PersonalDetails = {
  name: string
  email: string
  password: string
  confirmPassword: string
  phone: string // E.164
  couponCode?: string
  referralCode?: string
  billingCountry?: string // ISO2
}

export default function CheckoutPersonalForm({ value, onChange, disabledEmail, disabledReferral, hideCoupon }: { value: PersonalDetails; onChange: (patch: Partial<PersonalDetails>) => void; disabledEmail?: boolean; disabledReferral?: boolean; hideCoupon?: boolean }) {
  const typedConfirm = (value.confirmPassword || '').length > 0
  const matches = typedConfirm && value.confirmPassword === value.password

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label>Nome completo</Label>
        <Input value={value.name} onChange={(e)=> onChange({ name: e.target.value })} placeholder="Seu nome" required />
      </div>
      <div className="space-y-1.5">
        <Label>E-mail</Label>
        <Input value={value.email} onChange={(e)=> onChange({ email: e.target.value })} type="email" placeholder="voce@email.com" disabled={!!disabledEmail} required />
      </div>
      {!disabledEmail && (
        <PasswordWithConfirm
          password={value.password}
          confirm={value.confirmPassword}
          onChange={(p)=> onChange({ password: p.password ?? value.password, confirmPassword: p.confirm ?? value.confirmPassword })}
          required
          className=""
        />
      )}
      <PhoneInputIntl label="Telefone" value={value.phone} onChange={(e164)=> onChange({ phone: e164 })} required />
      {!hideCoupon && (
        <div className="space-y-1.5">
          <Label>Cupom de desconto</Label>
          <Input value={value.couponCode || ''} onChange={(e)=> onChange({ couponCode: e.target.value })} placeholder="Ex.: PROMO10" />
        </div>
      )}
      <div className="space-y-1.5">
        <Label>Codigo de Indicacao</Label>
        <Input value={value.referralCode || ''} onChange={(e)=> onChange({ referralCode: e.target.value })} placeholder="Ex.: meu-afiliado-123" disabled={!!disabledReferral} />
      </div>
    </div>
  )
}

export { CheckoutPersonalForm }
